import {useEffect,useState} from 'react';
import {doc,onSnapshot} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {eventCreatorName} from './eventCreator';

export default function useEventCreator(event,team){
 const uid=event.createdByUid||event.creatorUid||event.authorUid;
 const known=eventCreatorName(event,team),[record,setRecord]=useState(null);
 useEffect(()=>{
  if(!uid||known!=='Unknown creator')return undefined;
  let alive=true;
  const stop=onSnapshot(doc(db,'uids',uid),snapshot=>{if(alive)setRecord({uid,profile:snapshot.data()||{}});},()=>{});
  return()=>{alive=false;stop();};
 },[uid,known]);
 return eventCreatorName(event,team,record&&record.uid===uid?record.profile:{});
}
